const MILLISECONDS_PER_SECOND = 1000;

export const convertMillisecondsToSeconds = (timestamp?: number | null): number | null => {
    if (!timestamp) {
        return null;
    }
    return Math.floor(timestamp / MILLISECONDS_PER_SECOND);
};
